import { action } from 'sky-engine/api/index'

import { COLLECT_REPORT } from '@/api'

/**
 * 获取报告信息
 * @param {*} data
 * @returns
 */
export function getCollectList(data) {
  return action(COLLECT_REPORT, 'list', data)
}

/**
 * 获取工具下载链接
 * @returns
 */
export function getCollectToolUrl() {
  return action(COLLECT_REPORT, 'getCollectToolUrl', {})
}

/**
 * 获取工具下载链接
 * @returns
 */
export function getCheckToolUrl() {
  return action(COLLECT_REPORT, 'getCheckToolUrl', {})
}

/**
 * 获取报告软件列表
 * @returns
 */
export function getSoftwareList(data) {
  return action(COLLECT_REPORT, 'software/list', data)
}

/**
 * 获取报告外设列表
 * @returns
 */
export function getPeripheralList(data) {
  return action(COLLECT_REPORT, 'peripheral/list', data)
}
